import { z } from "zod";

export const ExecutionStatusValueSchema = z.enum(["running", "stopped"]);

export const ExecutionStatusResponseSchema = z.object({
	status: ExecutionStatusValueSchema,
});

export const ExecutionCommandResponseSchema = z.object({}).passthrough();

export type ExecutionStatusValue = z.infer<typeof ExecutionStatusValueSchema>;
export type ExecutionStatusResponse = z.infer<typeof ExecutionStatusResponseSchema>;
export type ExecutionCommandResponse = z.infer<typeof ExecutionCommandResponseSchema>;
